var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTasktype(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1983",
    xmlSpace: "preserve",
    width: 682.66669,
    height: 682.66669,
    viewBox: "0 0 682.66669 682.66669",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1987"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1997"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path1995"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g1989",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1991"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1993",
    clipPath: "url(#clipPath1997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1999",
    transform: "translate(472.1748,126.6992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-5.579 4.522,-10.102 10.102,-10.102 h 21.304 c -0.497,1.089 -1.177,2.097 -2.04,2.959 L 2.959,19.265 C 2.096,20.127 1.089,20.808 0,21.304 Z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero"
    },
    id: "path2001"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2003",
    transform: "translate(284.2842,126.6992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-5.579 4.523,-10.102 10.102,-10.102 h 21.304 c -0.496,1.089 -1.177,2.097 -2.039,2.959 L 2.959,19.265 C 2.097,20.127 1.09,20.808 0,21.304 Z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero"
    },
    id: "path2005"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2007",
    transform: "translate(96.3945,126.6992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-5.579 4.522,-10.102 10.102,-10.102 h 21.303 c -0.496,1.089 -1.176,2.097 -2.039,2.959 L 2.959,19.265 C 2.096,20.127 1.089,20.808 0,21.304 Z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero"
    },
    id: "path2009"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2011",
    transform: "translate(407.5244,338.8335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v 28.284 l -32.094,6.687 c -1.245,7.19 -3.118,14.166 -5.571,20.862 l 24.436,21.824 -14.143,24.495 -31.155,-10.263 c -4.622,5.524 -9.727,10.628 -15.25,15.251 l 10.262,31.155 -24.495,14.142 -21.823,-24.436 c -6.697,2.454 -13.673,4.326 -20.863,5.572 l -6.686,32.094 h -28.285 l -6.686,-32.094 c -7.19,-1.246 -14.166,-3.118 -20.863,-5.572 l -21.823,24.436 -24.495,-14.142 10.263,-31.155 c -5.524,-4.623 -10.628,-9.727 -15.25,-15.251 l -31.156,10.263 -14.142,-24.495 24.435,-21.824 c -2.453,-6.696 -4.326,-13.672 -5.571,-20.862 l -32.094,-6.687 V 0 l 32.094,-6.687 c 1.245,-7.19 3.118,-14.165 5.571,-20.862 l -24.435,-21.824 14.142,-24.495 31.156,10.263 c 4.622,-5.523 9.726,-10.628 15.25,-15.25 l -10.263,-31.156 24.495,-14.142 21.823,24.436 c 6.697,-2.453 13.673,-4.326 20.863,-5.572 l 6.686,-32.093 h 28.285 l 6.686,32.093 c 7.19,1.246 14.166,3.119 20.863,5.572 l 21.823,-24.436 24.495,14.142 -10.262,31.156 c 5.523,4.622 10.628,9.727 15.25,15.25 l 31.155,-10.263 14.143,24.495 -24.436,21.824 c 2.453,6.697 4.326,13.672 5.571,20.862 z",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2013"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2015",
    transform: "translate(329.96,402.2998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 9.43,-14.11 14.93,-31.08 14.93,-49.32 0,-49.1 -39.8,-88.9 -88.89,-88.9 -49.09,0 -88.89,39.8 -88.89,88.9 0,49.09 39.8,88.89 88.89,88.89 18.24,0 35.21,-5.5 49.32,-14.93",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2017"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2019",
    transform: "translate(193.3701,291.3555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v 1.01 c 0,20.082 16.283,36.366 36.365,36.366 h 52.53 c 20.082,0 36.365,-16.284 36.365,-36.366 V 0",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2021"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2023",
    transform: "translate(296.4062,369.1382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-22.316 -18.091,-40.406 -40.406,-40.406 -22.316,0 -40.407,18.09 -40.407,40.406 0,22.316 18.091,40.407 40.407,40.407 C -18.091,40.407 0,22.316 0,0 Z",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2025"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2027",
    transform: "translate(104.4756,352.9756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -36.366 V -204.053",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2029"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2031",
    transform: "translate(407.5244,352.9756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 36.366 V -204.053",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2033"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2035",
    transform: "translate(256,201.4512)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -52.528",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2037"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2039",
    transform: "translate(415.6055,116.5977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 24.244",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2041"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2043",
    transform: "translate(472.1748,84.2725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -56.569",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2045"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2047",
    transform: "translate(472.1748,51.9473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -56.569",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2049"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2051",
    transform: "translate(383.2803,72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -54.4 c 0,-5.58 4.52,-10.1 10.1,-10.1 h 101.02 c 5.58,0 10.1,4.52 10.1,10.1 v 94.81 c 0,2.68 -1.06,5.25 -2.96,7.15 l -26.41,26.4 c -1.89,1.9 -4.46,2.96 -7.14,2.96 H 10.1 C 4.52,76.92 0,72.4 0,66.82 V 35",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2053"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2055",
    transform: "translate(472.1748,148.0034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -21.304 c 0,-5.579 4.522,-10.102 10.102,-10.102 h 21.304",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2057"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2059",
    transform: "translate(227.7158,116.5977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 24.243",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2061"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2063",
    transform: "translate(284.2842,84.2725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -56.568",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2065"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2067",
    transform: "translate(284.2842,51.9473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -56.568",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2069"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2071",
    transform: "translate(306.5078,7.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -101.016 c -5.579,0 -10.101,4.522 -10.101,10.102 v 121.219 c 0,5.579 4.522,10.102 10.101,10.102 h 74.609 c 2.678,0 5.248,-1.065 7.142,-2.959 L 7.144,112.056 c 1.894,-1.894 2.958,-4.464 2.958,-7.142 V 10.102 C 10.102,4.522 5.579,0 0,0 Z",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2073"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2075",
    transform: "translate(284.2842,148.0034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -21.304 c 0,-5.579 4.523,-10.102 10.102,-10.102 h 21.304",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2077"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2079",
    transform: "translate(39.8252,116.5977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 24.244",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2081"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2083",
    transform: "translate(96.3945,84.2725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -56.569",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2085"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2087",
    transform: "translate(96.3945,51.9473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -56.569",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2089"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2091",
    transform: "translate(128.7197,49.27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -31.67 c 0,-5.58 -4.52,-10.1 -10.1,-10.1 h -101.02 c -5.58,0 -10.1,4.52 -10.1,10.1 V 89.55 c 0,5.58 4.52,10.1 10.1,10.1 h 74.61 c 2.68,0 5.25,-1.06 7.14,-2.96 L -2.96,70.29 C -1.06,68.39 0,65.82 0,63.14 V 35",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2093"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2095",
    transform: "translate(96.3945,148.0034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -21.304 c 0,-5.579 4.522,-10.102 10.102,-10.102 h 21.303",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2097"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasktype);
export default __webpack_public_path__ + "static/media/task type.24ab77d4bb4c60622afb61e708c78dbb.svg";
export { ForwardRef as ReactComponent };